// Client for the setup form.
//
// Nothing here is sent to Amazon. These are the seller's own figures and they
// only change what the features measure against.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/ads-setup`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  if (data.connected === false) throw new NotConnectedError(data.reason);
  return data;
};

export const getSetup = (token) => call(BASE, { headers: headers(token) });
export const saveSetup = (token, body) =>
  call(BASE, { method: 'POST', headers: headers(token), body: JSON.stringify(body) });
